export enum ModalTypes {
    Create = 1,
    Edit
}
